<template>
  <component :is="icon" v-if="icon" class="flex-shrink-0" />
</template>

<script>
export default {
  props: {
    /**
     * Can either be the name of the icon or include the subpath
     * eg: outline/cog
     */
    slug: { type: String, required: true },

    /**
     * The SVGs folder to look in, defaults to 'icons'.
     */
    root: { type: String, default: 'icons' },
  },

  data: () => ({
    icon: null,
  }),

  async created() {
    try {
      const response = await import(
        `@/assets/svg/${this.root}/${this.slug}.svg?inline`
      )

      this.icon = response?.default
    } catch (error) {
      console.error(error)
    }
  },
}
</script>
